import React from "react";
import checkImg from "./../../../Assets/Image/check.png";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import loadingGIf from "./../../../Assets/Image/loading.gif";

const RegistrationSuccess = () => {
  const [searchParams] = useSearchParams();
  const apiAddress = process.env.REACT_APP_SECRET;
  const [loading, setLoading] = React.useState(true);
  const [countdown, setCountdown] = React.useState(5);

  React.useEffect(() => {
    const userId = searchParams.get("id");
    const returnUrl = searchParams.get("returnUrl");

    if (!userId) return;

    const url = `${apiAddress}/api/GoTasteUser/${userId}/true`;

    axios
      .post(url)
      .then((response) => {
        console.log("res:", response.data);
        setLoading(false);

        if (returnUrl) {
          // Start countdown timer
          const interval = setInterval(() => {
            setCountdown((prev) => {
              if (prev <= 1) {
                clearInterval(interval);
                window.location.href = returnUrl;
                return 0;
              }
              return prev - 1;
            });
          }, 1000);

          // Cleanup interval if unmounted
          return () => clearInterval(interval);
        }
      })
      .catch((error) => {
        console.error("Verification error:", error);
        setLoading(false);
      });
  }, [searchParams, apiAddress]);

  const returnUrl = searchParams.get("returnUrl");

  return (
    <div style={{ height: "100vh" }}>
      {/* Success Section */}
      <div className={`${loading ? "d-none" : "h-100"}`}>
        <div
          className="d-flex align-items-center justify-content-center h-100"
          style={{ flexDirection: "column" }}
        >
          <img src={checkImg} alt="Success" style={{ width: "5rem" }} />
          <h2>Verification Successful</h2>
          <p className="text-center">
            Thank you for verifying your account.
            <br />
            You can now log in and order.
          </p>

          {returnUrl ? (
            <p className="text-muted">
              Redirecting in <strong>{countdown}</strong> seconds...
            </p>
          ) : (
            <h6
              style={{ cursor: "pointer" }}
              onClick={() => {
                window.location.href = "/";
              }}
            >
              Go to home
            </h6>
          )}
        </div>
      </div>

      {/* Loading Section */}
      <div
        className={`${
          loading
            ? "d-flex align-items-center justify-content-center h-100"
            : "d-none"
        }`}
      >
        <img src={loadingGIf} alt="Loading..." />
      </div>
    </div>
  );
};

export default RegistrationSuccess;
